export default class series {
  title: string;
  flavortext: string;
  color?: string | null;
  validGames: string[][];
  validPlatformStacks: string[][];

  constructor(
    _title: string,
    _flavortext: string,
    _color: string | null,
    _validGames: string[][],
    _validPlatformStacks: string[][]
  ) {
    this.title = _title;
    this.flavortext = _flavortext;
    this.color = _color;
    this.validGames = _validGames;
    this.validPlatformStacks = _validPlatformStacks;
  }
}
